import { render, staticRenderFns } from "./ReposicionFondo.vue?vue&type=template&id=4dd43754&"
import script from "./ReposicionFondo.vue?vue&type=script&lang=js&"
export * from "./ReposicionFondo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ReposicionFondo.vue"
export default component.exports